import React, { Component } from "react";
import { toast } from "react-toastify";
import UpLoadContentForm from "./UploadContentsForm";
import { upLoadService } from "./services/Upload";
import ConfirmationModal from "../../../Shared/ConfirmationModal";

class ManageUpLoadContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            showModal: false,
            submitSucessful: false,
            isEdit: false,
            postInterest: null,
            postTitle: null,
            postBody: null,
            imageUrl: null,
            interestId: null,
            isPublishClick: false,
            publishPost: null,
            postId: null,
            newPost: false,
            resetFormAfterPub: false,
            instructorInterests: null,
            stripPastedStyles: true,
            declineComment: null,
            showNextJoyRide: false,
        };
        this.changeFromDeclineToDraft = this.changeFromDeclineToDraft.bind(this);
    }
    componentDidMount() {
        if (this.props.location.state) {
            if (Object.keys(this.props.location.state)[0] === "run") {
                const { run } = this.props.location.state;
                this.setState({ showNextJoyRide: run ? run : false });
            } else {
                
                const { postId } = this.props.location.state;
                if (this.props.location.state.change === "decline") {
                    this.changeFromDeclineToDraft(postId);
                } else {
                    this.setState({ postId: postId });

                    this.getPostsById(postId);
                }
            }
        }
        this.getInstructorInterest();
    }
    changeDeclineStatus = (id) => {
        upLoadService
            .changePostStatus(id)
            .then((response) => {
                this.setState({ postId: id });
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
    };

    async changeFromDeclineToDraft(id) {
        try {
            await this.changeDeclineStatus(id);
        } catch (e) {
            this.setState({ formError: "fail to fetch data", submitting: false });
        }
        return this.getPostsById(id);
    }

    refreshComponent = () => {
        this.setState({
            fetching: false,
            submitting: false,
            formError: null,
            data: null,
            showModal: false,
            submitSucessful: false,
            isEdit: false,
            postInterest: null,
            postTitle: null,
            postBody: null,
            interestId: null,
            isPublishClick: false,
            publishPost: null,
            postId: null,
            newPost: false,
            resetFormAfterPub: false,
            instructorInterests: null,
            stripPastedStyles: true,
            declineComment: null,
        });
    };

    getInstructorInterest = () => {
        upLoadService
            .getSpecificInstructorInterest()
            .then((response) => {
                this.setState({
                    instructorInterests: response.content,
                });
            })

            .catch((error) => this.setState({ formError: error, submitting: false }));
    };
    getInterestId = (data) => {
        this.setState({ interestId: data.content[0].id, newPost: true });
    };

    submitPost = (data) => {
        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
        });
        upLoadService
            .submitPost(data)
            .then((response) => {
                this.setState({
                    response,
                    formError: null,
                    submitting: false,
                    submitSucessful: true,
                    showModal: !this.state.showModal,
                    newPost: false,
                    declineComment: null,
                    resetFormAfterPub: true,
                    postId: null,
                });
                toast.success("Post submitted successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                this.resetButton();
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
    };

    UpdateSubmitPost = (data, postId) => {
        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
        });
        upLoadService
            .updateSubmitPost(data, postId)
            .then((response) => {
                this.setState({
                    response,
                    formError: null,
                    submitting: false,
                    submitSucessful: true,
                    showModal: !this.state.showModal,
                    newPost: false,
                    declineComment: null,
                    resetFormAfterPub: true,
                    postId: null,
                });
                toast.success("Post submitted successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
                this.resetButton();
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
    };

    draftPost = (data) => {
        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
        });
        upLoadService
            .draftPost(data)
            .then((response) => {
                this.setState({
                    response,
                    formError: null,
                    submitting: false,
                    postId: response.id,
                });
                toast.success("Draft saved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
    };

    updateDraftPost = (data, PostId) => {
        this.setState({
            submitting: true,
            formError: null,
            submitSucessful: false,
        });
        upLoadService
            .updateDraftPost(data, PostId)
            .then((response) => {
                this.setState({
                    response,
                    formError: null,
                    submitting: false,
                });
                toast.success("Draft saved successfully", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 4000,
                });
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
    };

    checkDraftStatus = (data) => {
        if (this.state.postId === null) {
            this.draftPost(data);
        } else {
            this.updateDraftPost(data, this.state.postId);
        }
    };

    checkUpdatePost = (data) => {
        this.UpdateSubmitPost(data, this.state.postId);
    };
    checkPublishStatus = (data) => {
        if (this.state.postId === null) {
            this.submitPost(data);
        } else {
            let newRefineData = {
                ...data,
                draftId: this.state.postId,
            };

            this.submitPost(newRefineData);
        }
    };

    getPostsById = (id) => {
        this.setState({ submitting: true, stripPastedStyles: false });
        upLoadService
            .getPost(id)
            .then((response) => {
                response &&
                    this.setState({
                        postInterest: response.interestName,
                        postTitle: response.title,
                        postBody: response.body,
                        interestId: response.interestId,
                        declineComment: response.reviewerRemarks,
                        imageUrl: response.imageUrl,
                        formError: null,
                        submitting: false,
                        submitSucessful: false,
                        error: null,
                        fetching: false,
                        isEdit: true,
                    });
            })
            .catch((error) => this.setState({ formError: error, submitting: false }));
        this.setState({ stripPastedStyles: true });
    };

    setImageNull = () => {
        this.setState({ imageUrl: null });
    };

    resetButton = () => {
        this.setState({
            fetching: false,
            submitting: false,
            formError: null,
            showModal: false,
            data: null,
            resetFormAfterPub: true,
            submitSucessful: false,
            isEdit: false,
        });
    };
    resetForm = () => {
        this.setState({ resetFormAfterPub: false });
    };
    showConfirmation = (data) => {
        this.setState({
            publishPost: data,
            showModal: !this.state.showModal,
        });
    };
    stopEdit = () => {
        this.setState({
            isEdit: false,
        });
    };
    //========================TOUR GUIDE========================//
    setNextJoyRide = () => {
        this.setState({ showNextJoyRide: false });
    };

    startJoyRideAtDataTable = () => {
        this.setState({ showJoyRideOnTable: true });
    };

    stopJoyRideAtDataTable = () => {
        this.setState({ showJoyRideOnTable: false });
    };

    routeChange = () => {
        this.props.history.push({
            pathname: `/dashboard`,
            state: { run: false },
        });
    };
    render() {
        const { submitting, formError, isEdit, postInterest, postTitle, postBody, interestId, submitSucessful, isPublishClick, publishPost, newPost, resetFormAfterPub, instructorInterests, stripPastedStyles, declineComment, imageUrl, showNextJoyRide, postId } = this.state;

        return (
            <div>
                <UpLoadContentForm
                    submitting={submitting}
                    submitSucessful={submitSucessful}
                    submitDraftPost={this.checkDraftStatus}
                    submitPublishPost={this.showConfirmation}
                    error={formError}
                    isEdit={isEdit}
                    postInterest={postInterest}
                    postTitle={postTitle}
                    postBody={postBody}
                    stopEdit={this.stopEdit}
                    interestId={interestId}
                    getDataFromForm={this.getDataFromForm}
                    isPublishClick={isPublishClick}
                    getInterestId={this.getInterestId}
                    newPost={newPost}
                    resetFormAfterPub={resetFormAfterPub}
                    instructorInterests={instructorInterests}
                    stripPastedStyles={stripPastedStyles}
                    declineComment={declineComment}
                    imageUrl={imageUrl}
                    setImageNull={this.setImageNull}
                    showNextJoyRide={showNextJoyRide}
                    setNextJoyRide={this.setNextJoyRide}
                    routeChange={this.routeChange}
                    editedPostId={postId}
                />

                <ConfirmationModal isOpen={this.state.showModal} showModal={this.showConfirmation} action={postId ? () => this.checkUpdatePost(publishPost) : () => this.checkPublishStatus(publishPost)} message={"Do you want to submit your post for approval?"} error={formError} />
            </div>
        );
    }
}

export default ManageUpLoadContent;
